import { Injectable } from '@angular/core';

import { IConstant, IDocRef, IHandicapOutcome, ILeg } from '@frontend/oxygen/shared-utils';
import * as _ from 'underscore';

import { handicapByMarketCode, modelByType } from '../../constants/bet-slip.constant';
import { IBetSelection } from '../betSelection/bet-selection.model';
import { ComplexLegService } from '../complexLeg/complex-leg.service';
import { ForecastSportsLegService } from '../forecastSportsLeg/forecast-sports-leg.service';
import { HandicapSportsLegService } from '../handicapSportsLeg/handicap-sports-leg.service';
import { Leg } from '../leg/leg';
import { ScorecastSportsLegService } from '../scorecastSportsLeg/scorecast-sports-leg.service';
import { SportsLeg } from '../sportsLeg/sports-leg';
import { SportsLegService } from '../sportsLeg/sports-leg.service';

@Injectable({ providedIn: 'root' })
export class LegFactoryService {
    constructor(
        private complexLegService: ComplexLegService,
        /* eslint-disable @typescript-eslint/no-unused-vars */
        // @ts-ignore
        private sportsLegService: SportsLegService, // @ts-ignore
        private forecastSportsLegService: ForecastSportsLegService, // @ts-ignore
        private handicapSportsLegService: HandicapSportsLegService, // @ts-ignore
        private scorecastSportsLegService: ScorecastSportsLegService,
        /* eslint-enable @typescript-eslint/no-unused-vars */
    ) {}

    constructLegs(selections: IBetSelection[] | any): SportsLeg[] {
        if (selections.length && selections[0].isLotto) {
            return selections;
        }
        return selections.reduce((legsEntity: Array<SportsLeg>, sel: IBetSelection) => {
            if (sel.isFCTC) {
                return _.union(legsEntity, this.complexLegService.getTricastForecastLegs(sel, legsEntity));
            }

            const straightLeg = [this.constructStrategy(sel, legsEntity.length + 1)],
                eachWayLeg = sel.hasEachWay ? [this.constructStrategy(sel.eachWayOn as IBetSelection, legsEntity.length + 2)] : [];
            return _.union(legsEntity, straightLeg, eachWayLeg);
        }, []);
    }

    parseLegs(docs: ILeg[]): ILeg[] {
        return _.map(docs, this.parseStrategy.bind(this));
    }

    private parseStrategy(doc: IDocRef): Leg {
        const type = this.parseCombiType(doc) || this.parseHandicapRangeType(doc) || 'SGL',
            modelClass = this.getModelClass(type);
        return modelClass.parseAndConstruct(doc);
    }

    private constructStrategy(selection: IBetSelection, index: number): SportsLeg | {} {
        const type = this.selectHandicapRangeType(selection) || selection.type,
            model = this.getModelClass(type);
        return model ? model.construct(selection, index) : {};
    }

    private getModelClass(type: string | number): SportsLegService | ForecastSportsLegService | ScorecastSportsLegService | HandicapSportsLegService {
        const className = type && (modelByType as { [key: string]: any })[type];
        return (this as IConstant)[className];
    }

    private selectHandicapRangeType(selection: IBetSelection): string {
        const handicapType = (<IHandicapOutcome>selection.handicap)?.type;
        return (handicapByMarketCode as IConstant)[handicapType];
    }

    private parseHandicapRangeType(doc: IDocRef): number | string | undefined {
        return doc.sportsLeg && doc.sportsLeg.legPart && doc.sportsLeg.legPart[0].range ? doc.sportsLeg.legPart[0].range.rangeTypeRef?.id : '';
    }

    private parseCombiType(doc: IDocRef): string {
        return doc.sportsLeg && doc.sportsLeg.outcomeCombiRef ? <string>doc.sportsLeg.outcomeCombiRef?.id : '';
    }
}
